module.exports = __webpack_public_path__ + "assets/img/why-carpool.83ae35ba.jpg";